import * as React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"
import SideBar from "../components/menu"
import wordpressIcon from "../images/wordpress-black.svg"
import html5Icon from "../images/html5-black.svg"
import css3Icon from "../images/css3-black.svg"
import phpIcon from "../images/php.svg"
import jsIcon from "../images/js-black.svg"
import reactIcon from "../images/react.svg"
import gitIcon from "../images/git-black.svg"
import cpanelIcon from "../images/cpanel-black.svg"
import gatsbyIcon from "../images/gatsby-logo.jpg"
import wpStud from "../images/hero-code.jpg"
import * as s from "./index.module.css"

const IndexPage = () => {

  const greenPara = {
    background: '#6aaf08',
    borderRadius: '6px',
    color: 'white',
    fontWeight: '500'
  }

  const recentImg = {
    backgroundImage: `URL(${wpStud})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100%',
    borderRadius: '6px',
  }

  return (
    <>
      <Helmet>
        <title>home | webdev@planet64</title>
        <meta name="robots" content="noindex follow" />
        <meta name="description" content="We provide full website development, management and hosting services to small to medium businesses as well as web development freelance services." />
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <SideBar />
          <main className="col-12 col-lg-9">
            <div className="py-5 p-lg-5">

              <div className="mt-0 d-flex flex-wrap hero-benefits justify-content-center justify-content-md-between">
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={wordpressIcon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={html5Icon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={css3Icon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={phpIcon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={jsIcon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={reactIcon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={gitIcon} alt="icon" />
                </div>
                <div className={`${s.skills} hero-feature mx-3 mx-xl-0 mb-2 mb-md-0`}>
                  <img src={cpanelIcon} alt="icon" />
                </div>
              </div>

              <div className="row gx-lg-5 mt-5">
                <div className="col-12 col-lg-6">
                  <h1 className="h5 mb-3">about me... <img src={gatsbyIcon} alt="gatsby logo" style={{ maxHeight: '25px' }} /></h1>
                  <p>I'm as simple single page application created using the <strong>React</strong> Framework, <strong>Gatsby</strong>. I currently reside on the <strong>Netlify</strong> CDN, a high performance hosting service that <a href="https://builtwith.com/?https%3a%2f%2fwebdev.planet64.eu" target="_blank" rel="noreferrer noopener">builds me</a> prior to deployment to ensure a super slick experience to those who wish to visit me. </p>
                  <p>I'm told that over time I'll become more, a <strong>headless CMS</strong> will be hooked up so I can use my <strong>GraphQL</strong> skills to build a site that will be fresh with new content and seperate code from content.</p>

                </div>
                <div className="col-12 col-lg-6">
                  <h2 className="h5 mb-3">... but what about Alex?</h2>
                  <p>I'm an IT professional who specialises in <strong>web development</strong>, primarily front end but have years of experience working with backend technologies as well as systems admin. At present I'm available for <strong>freelance</strong> work and <strong>contract</strong> work.</p>
                  <p>I live in sunny Spain and operate a small web dev and hosting service for over 100 clients. You can view more details on my career on the <Link to="/timeline/" >timeline</Link> page.</p>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-12 col-lg-6">
                  <h2 className="h5 mb-3">recent web projects</h2>
                  <p className="p-3 mb-0" style={greenPara}>For over 10 years now I've been working remotely from my office in Spain for 2 large IT companies based in the UK. Both were full-time contracts. At present i'm working on a freelance basis for the latter of the two - waracle. Sadly i can't showcase any of this so i'm building up a portfolio of recent work I've carried out for small to medium business in the UK and Spain.</p>
                </div>

                <div className="col-12 col-lg-6">
                  <div style={recentImg}></div>
                </div>
              </div>

              <div className="row  pb-3 mt-5">
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <img src="https://studio.planet64.eu/wp-content/uploads/2024/05/web-dev.jpg" className="mw-100 br-6" alt="website screen" />
                </div>
                <div className="col-12 col-md-8 col-xl-7 align-content-center">
                  <div className={`${s.hero_intro} mw-100 d-block p-4`}>
                    <p className="mb-0"><strong>EDI Rent A Car</strong> are a British family run business based in El Campello about 20 minutes north of Alicante Airport. All of the staff are English speaking as well as fluent in Spanish. They needed a modern website that allowed potential clients to obtain a quote based on their pricing system, as well as the capability to have the site presented in multiple languages.<br /><br /><span><strong>completion date</strong>: May 2024</span></p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mt-3">
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/screwdriver-wrench-solid.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/equals-solid.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/wordpress-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/html5-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/css3-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/bootstrap-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/js-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/git-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/cpanel-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl-5">
                  <div className="text-end mt-3">
                    <a href="https://www.edirentacar.com/" target="_blank" rel="noopener noreferrer">www.edirentacar.com</a>
                  </div>
                </div>
              </div>
              <div className="row  pb-3 mt-5">
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <img src="https://studio.planet64.eu/wp-content/uploads/2024/05/studio-mock-1-600x400.png" className="mw-100 br-6" alt="website screen" />
                </div>
                <div className="col-12 col-md-8 col-xl-7 align-content-center">
                  <div className={`${s.hero_intro} mw-100 d-block p-4`}>
                    <p className="mb-0">We put studio together to allow us to separate our creative work from the web hosting side of the business. planet64 has been around since 2007, formerly known as Mantis Design before rebranding in early 2011. We've served 100's of customers over the years including web design, web hosting as well as design and print.<br /><br /><span><strong>completion date</strong>: April 2024</span></p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mt-3">
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/screwdriver-wrench-solid.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/equals-solid.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/wordpress-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/html5-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/css3-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/bootstrap-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/js-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/git-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                    <img src="https://studio.planet64.eu/wp-content/themes/planet-six-four-studio/assets/img/cpanel-black.svg" className="mt-2 me-2" style={{ height: '25px' }} alt="icon" />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl-5">
                  <div className="text-end mt-3">
                    <a href="https://studio.planet64.eu/" style={{ fontWeight: '500' }} target="_blank" rel="noopener noreferrer">studio.planet64.eu</a>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

    </>

  )
}

export default IndexPage
